<template>
    <div class="filters-root px-2 py-2">
        <div
            style="height: 90%;"
            :class="{
                'd-flex': true,
                'align-items-center': true,
                'flex-column': filterOrientation == 'vertical',
                'py-3': filterOrientation == 'vertical',
            }"
        >
            <BaseIcon name="filter" size="xs" />
            <div
                :class="{
                    'd-flex': true,
                    'align-items-center': true,
                    'flex-column': filterOrientation == 'vertical',
                    'w-100': filterOrientation == 'vertical',
                }"
            >
                <FilterBuilder
                    v-for="filter in filters"
                    :key="filter.label"
                    :label="filter.label"
                    :options="filter.options"
                    :settings="filter.settings"
                    :value="value"
                    :yOffset="filterOrientation == 'vertical' ? 50 : undefined"
                    :maxHeight="filterOrientation == 'vertical' ? undefined : 300"
                    :class="{
                        'py-2': filterOrientation == 'vertical',
                        'my-2': filterOrientation == 'vertical',
                        altPlacement: filterOrientation == 'vertical',
                        'w-100': filterOrientation == 'vertical',
                        'text-center': true,
                    }"
                    @update:filter="updateFilter"
                />
                <DateFilter
                    :label="$t('cts.startDate')"
                    filterLabel="start_date"
                    :value="value"
                    :class="{
                        'py-2': filterOrientation == 'vertical',
                        'my-2': filterOrientation == 'vertical',
                        altPlacement: filterOrientation == 'vertical',
                        'w-100': filterOrientation == 'vertical',
                        'text-center': true,
                    }"
                    @update:filter="updateFilter"
                />
            </div>
            <div style="flex: 1;" />
            <BaseButton
                size="xs"
                class="d-flex align-items-center"
                :variant="hasFiltersChanged ? 'secondary' : 'outline-secondary'"
                outline
                @click="clearFilters"
            >
                <BaseIcon name="times" />
                <h6 class="inherit-color subtitle bold m-0 pl-2">
                    {{ $t('shared.searchModule.filters.clearFilters') }}
                </h6>
            </BaseButton>
        </div>
    </div>
</template>

<script>
import FilterBuilder from './FilterBuilder';
import DateFilter from './DateFilter';

export default {
    name: 'Filters',
    components: { FilterBuilder, DateFilter },
    props: {
        value: Object,
        filters: Array,
        hasFiltersChanged: Boolean,
        filterOrientation: String,
    },
    methods: {
        clearFilters() {
            this.$emit('clear:filter', {});
        },
        updateFilter(val) {
            if (val) {
                this.$emit('update:filter', val);
            }
        },
    },
};
</script>

<style scoped>
.filters-root {
    background-color: #fcfcfc;
    height: 100%;
    border-radius: inherit;
}
</style>
